import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dashboard-inspection-list',
  standalone: false,
  templateUrl: './dashboard-inspection-list.component.html',
  styleUrls: ['./dashboard-inspection-list.component.scss'],
})
export class DashboardInspectionListComponent implements OnChanges {
  @Input() rows: any[] = [];
  @Input() loading = false;
  @Input() noDataText = 'No overdue inspections.';

  readonly displayedColumns: string[] = ['No', 'Project', 'CreatedOn', 'DaysOpen', 'Status'];
  readonly dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    if (value) {
      this.dataSource.paginator = value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rows']) {
      this.dataSource.data = this.rows ?? [];
      this.dataSource.paginator?.firstPage();
    }
  }

  getDaysOpenClass(days: number): string {
    if (days > 14) return 'danger';
    if (days > 7) return 'warning';
    return 'ok';
  }

  getStatusClass(status: string): string {
    const value = (status || '').toLowerCase();

    if (value === 'open') return 'status-open';
    if (value === 'submitted') return 'status-submitted';
    if (value === 'closed') return 'status-closed';
    return 'status-default';
  }
}
